interface InviteResponse {
  ok: true;
  inviteUrl: string;
  shareUrl: string;
}

interface InviteFailure {
  ok?: false;
  message?: string;
}

interface TelegramInviteWebApp {
  openTelegramLink?: (url: string) => void;
  openLink?: (url: string) => void;
  showAlert?: (message: string) => void;
}

function showError(message: string): void {
  const telegram = (
    window as Window & { Telegram?: { WebApp?: TelegramInviteWebApp } }
  ).Telegram?.WebApp;
  if (telegram?.showAlert) {
    telegram.showAlert(message);
    return;
  }
  window.alert(message);
}

function openTelegramShare(url: string): void {
  const telegram = (
    window as Window & { Telegram?: { WebApp?: TelegramInviteWebApp } }
  ).Telegram?.WebApp;
  if (telegram?.openTelegramLink) {
    telegram.openTelegramLink(url);
    return;
  }
  if (telegram?.openLink) {
    telegram.openLink(url);
    return;
  }
  window.location.assign(url);
}

function installTeamInviteUi(): void {
  const form = document.getElementById('shareKitForm');
  const input = document.getElementById('shareTelegramId');
  const select = document.getElementById('manageKitSelect');
  const button = form?.querySelector<HTMLButtonElement>('button[type="submit"]');
  if (!(form instanceof HTMLFormElement) || !(select instanceof HTMLSelectElement) || !button) {
    return;
  }

  if (input instanceof HTMLInputElement) {
    input.required = false;
    input.hidden = true;
    input.tabIndex = -1;
  }
  form.style.gridTemplateColumns = '1fr';
  button.textContent = 'Пригласить';
  button.style.width = '100%';

  form.addEventListener(
    'submit',
    async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const kitId = select.value;
      if (!kitId) {
        showError('Сначала выберите бренд-набор.');
        return;
      }

      const previousText = button.textContent;
      button.disabled = true;
      button.textContent = 'Готовим приглашение…';
      try {
        const response = await fetch(`/api/kits/${encodeURIComponent(kitId)}/invite`, {
          method: 'POST',
          credentials: 'same-origin',
        });
        const payload = (await response.json().catch(() => null)) as
          | InviteResponse
          | InviteFailure
          | null;
        if (!response.ok || !payload || payload.ok !== true || !('shareUrl' in payload)) {
          const failureMessage = payload && 'message' in payload ? payload.message : undefined;
          throw new Error(failureMessage ?? 'Не удалось создать приглашение.');
        }
        openTelegramShare(payload.shareUrl);
      } catch (error) {
        showError(error instanceof Error ? error.message : 'Не удалось создать приглашение.');
      } finally {
        button.disabled = false;
        button.textContent = previousText || 'Пригласить';
      }
    },
    { capture: true },
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', installTeamInviteUi, { once: true });
} else {
  installTeamInviteUi();
}
